<template lang="pug">
v-dialog(v-model="show" persistent max-width="700px" scrollable :fullscreen="$vuetify.breakpoint.smAndDown" )
    v-card.d-flex.flex-column(height="600px")
        v-card-title.headline {{ $t('importAttendanceDialog.dialogTitle') }}
        v-card-text(v-if="$vuetify.breakpoint.mdAndUp")
            v-form(ref="form" v-model="isFormValid" :lazy-validation="true" :disabled="isSaveInProgress || isFormDisabled")
                v-row.ma-0.mt-2(no-gutters)
                    v-col.pa-0(cols="5")
                        v-menu(
                            v-model="dateRangeMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        )
                            template(v-slot:activator="{ on, attrs }")
                                v-text-field(
                                    v-model="dateRangeFormatted"
                                    outlined
                                    :label="$t('importAttendanceDialog.dateRangeSelectorLabel')"
                                    prepend-icon="fas fa-calendar-alt"
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                    clear-icon="fal fa-times"
                                    readonly
                                    :rules="[v => !!v || $t('importAttendanceDialog.dateRangeRequired')]"
                                )
                            v-date-picker(
                                v-model="dateRange"
                                range
                                no-title
                                first-day-of-week="1"
                                show-week
                                prev-icon="fas fa-chevron-left"
                                next-icon="fas fa-chevron-right"
                            )
                    v-spacer
                    v-col.mt-4.pr-2.text-end(cols="2")
                      v-icon fas fa-user
                    v-col(cols="5")
                        v-select(
                            ref="customerSelector"
                            v-model="selectedCustomer"
                            append-icon="fas fa-chevron-down"
                            outlined item-value="id"
                            item-text="name"
                            return-object
                            :items="customerList"
                            :label="$t('importAttendanceDialog.customerSelectorLabel')"
                            :rules="[v => !!v || $t('importAttendanceDialog.customerRequired')]"
                        )
                v-row
                    v-col(cols="12")
                        v-file-input(
                            v-model="selectedFile"
                            outlined
                            type="file"
                            accept=".xlsx"
                            prepend-icon="fas fa-clipboard-user"
                            :rules="[v => !!v || $t('importAttendanceDialog.fileRequired')]"
                            :label="$t('importAttendanceDialog.fileLabel')"
                        )
                v-row(no-gutters)
                    v-col(cols="12")
                        v-card-actions.pr-0
                           v-spacer
                           v-btn(color="primary" :disabled="!isFormValid || isSaveInProgress || isFormDisabled" @click="onSubmitButtonClick" :loading="isSaveInProgress") {{ $t('importAttendanceDialog.submitButtonLabel') }}

            template.import-success(v-if="importSuccess")
                v-row(no-gutters)
                    v-col.ma-0(cols="12")
                        v-alert.ma-0(
                            type="success"
                            icon="fas fa-exclamation-circle"
                        ) {{ $t('importAttendanceDialog.importSuccessMessage') }}

            template.import-failure(v-if="importFailed")
                v-divider

                v-row
                    v-col(cols="12")
                        v-alert(
                            type="error"
                            icon="fas fa-exclamation-circle"
                        ) {{ $t('importAttendanceDialog.importFailedMessage') }}
                v-row(no-gutters )
                    v-col.ma-0(cols="12")
                      ErrorResponseViolations(:error-response="errorResponse")
        v-card-text.flex-shrink-0.flex-grow-1.pb-0(v-else style="height: 400px; overflow-y: scroll")
            v-form(ref="form" v-model="isFormValid" :lazy-validation="true" :disabled="isSaveInProgress || isFormDisabled")
                v-row
                    v-col(cols="12")
                        v-menu(
                            v-model="dateRangeMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        )
                            template(v-slot:activator="{ on, attrs }")
                                v-text-field(
                                    v-model="dateRangeFormatted"
                                    outlined
                                    :label="$t('importAttendanceDialog.dateRangeSelectorLabel')"
                                    prepend-icon="fas fa-calendar-alt"
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                    clear-icon="fal fa-times"
                                    readonly
                                    :rules="[v => !!v || $t('importAttendanceDialog.dateRangeRequired')]"
                                )
                            v-date-picker(
                                v-model="dateRange"
                                range
                                no-title
                                first-day-of-week="1"
                                show-week
                                prev-icon="fas fa-chevron-left"
                                next-icon="fas fa-chevron-right"
                            )
                    v-col.mt-4(cols="1")
                        v-icon fas fa-user
                    v-col(cols="11")
                        v-select(
                            ref="customerSelector"
                            v-model="selectedCustomer"
                            append-icon="fas fa-chevron-down"
                            outlined item-value="id"
                            item-text="name"
                            return-object
                            :items="customerList"
                            :label="$t('importAttendanceDialog.customerSelectorLabel')"
                            :rules="[v => !!v || $t('importAttendanceDialog.customerRequired')]"
                        )
                v-row
                    v-col(cols="12")
                        v-file-input(
                            v-model="selectedFile"
                            outlined
                            type="file"
                            accept=".xlsx"
                            prepend-icon="fas fa-clipboard-user"
                            :rules="[v => !!v || $t('importAttendanceDialog.fileRequired')]"
                            :label="$t('importAttendanceDialog.fileLabel')"
                        )
                v-row(no-gutters)
                    v-col(cols="12")
                        v-card-actions.pr-0
                            v-spacer
                            v-btn(color="primary" :disabled="!isFormValid || isSaveInProgress || isFormDisabled" @click="onSubmitButtonClick" :loading="isSaveInProgress") {{ $t('importAttendanceDialog.submitButtonLabel') }}

            template.import-success(v-if="importSuccess")
                v-row(no-gutters)
                    v-col.ma-0(cols="12")
                        v-alert.ma-0(
                            type="success"
                            icon="fas fa-exclamation-circle"
                        ) {{ $t('importAttendanceDialog.importSuccessMessage') }}

            template.import-failure(v-if="importFailed")
                v-divider

                v-row
                    v-col(cols="12")
                        v-alert(
                            type="error"
                            icon="fas fa-exclamation-circle"
                        ) {{ $t('importAttendanceDialog.importFailedMessage') }}
                v-row(no-gutters )
                    v-col.ma-0(cols="12")
                        ErrorResponseViolations(:error-response="errorResponse")
        v-divider
        v-card-actions
            v-spacer
            v-btn(color="primary" text :disabled="isSaveInProgress" @click="onCloseButtonClick") {{ $t('buttons.closeButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import moment from 'moment'
import Customer from '@/model/customer/Customer'
import {Action} from 'vuex-class'
import {CUSTOMER_FETCH_CUSTOMER_LIST} from '@/store/action-types'
import {UploadAttendanceFilePayload} from '@/types/payload'
import axios from '@/plugins/axios'
import _ from 'lodash'
import {AxiosError} from 'axios'
import ErrorResponseViolations from '@/components/ErrorResponseViolations.vue'


@Component({
  components: {
    ErrorResponseViolations
  }
})
export default class ImportAttendanceDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean

  $refs!: {
    form: Vue & { validate: () => boolean }
  }

  private isFormValid: boolean = false
  private isSaveInProgress: boolean = false
  private dateRangeMenu: boolean = false
  private dateRange: string[] = []
  private customerList: Customer[] = []
  private selectedCustomer: Customer | null = null
  private selectedFile: File | null = null
  private importFailed: boolean = false
  private importSuccess: boolean = false
  private errorResponse: AxiosError | null = null
  private errorViolations: boolean = false
  private isFormDisabled: boolean = false

  @Action(CUSTOMER_FETCH_CUSTOMER_LIST) fetchCustomers!: { (): Promise<Customer[]> }

  @Watch('importFailed')
  watchIsUpdate (newVal: boolean) {
      if (newVal && newVal === true) {
          this.selectedFile = null
      }
  }

  get dateRangeFormatted() {
    return this.dateRange
      .map((date: string) => moment(date).format('D.M.YYYY'))
      .join(' - ')
  }

  onCloseButtonClick(): void {
    this.$emit('close')
  }

  onSubmitButtonClick(): void {
    if (this.$refs.form.validate()) {
      this.submitAttendanceFile()
    }
  }

  async submitAttendanceFile(): Promise<void> {
    this.isSaveInProgress = true
    this.importSuccess = false
    this.importFailed = false

    try {
      const sortedDateRange = _.sortBy(this.dateRange, (date: string) => moment(date).valueOf())

      const payload: UploadAttendanceFilePayload = {
        periodStart: sortedDateRange[0],
        periodEnd: sortedDateRange[1],
        customer: this.selectedCustomer!.iri,
        data: await this.createDataUrlFromSelectedFile()
      }

      const response = await axios.post('/api/attendance-file', payload)

      if (response.status === 201) {
        this.importSuccess = true
          this.isFormDisabled = true
      }
    } catch (error: AxiosError | Error | any) {
      this.importFailed = true

      if ('isAxiosError' in error && error && error.isAxiosError) {
        this.errorResponse = error
      } else if(error.status === 422) {
          this.errorViolations = true
      }
    } finally {
      this.isSaveInProgress = false
    }
  }

  async createDataUrlFromSelectedFile(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('FileReader result is not a string.'));
        }
      };

      reader.onerror = () => {
        reject(new Error('An error occurred while reading the file.'));
      };

      reader.readAsDataURL(this.selectedFile!);
    });
  }


  async mounted() {
    this.customerList = await this.fetchCustomers()
  }
}

</script>

<style lang="stylus" scoped>
.card-body
  overflow auto
</style>
